import useScrollSpy from '../../hooks/useScrollSpy';
import { scrollToSection } from '../../utils/scrollTo';

const NAV_ITEMS = [
  { id: 'about', label: 'About', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
  { id: 'projects', label: 'Work', icon: 'M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z' },
  { id: 'impact', label: 'Impact', icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6' },
  { id: 'contact', label: 'Contact', icon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
];

const MobileNav = () => {
  const activeSection = useScrollSpy(['about', 'projects', 'impact', 'contact'], 160);

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-ant-line-soft bg-ant-bg/95 backdrop-blur-xl safe-bottom"
      aria-label="Mobile section navigation"
    >
      <ul className="flex items-stretch justify-around px-2 pt-2 pb-1">
        {NAV_ITEMS.map((item) => {
          const isActive = activeSection === item.id;
          return (
            <li key={item.id} className="flex-1 max-w-[80px]">
              <button
                onClick={() => scrollToSection(item.id)}
                className={`flex flex-col items-center justify-center w-full py-2 px-1 rounded-xl transition-all min-h-[52px] ${
                  isActive ? 'text-ant-gold bg-white/[0.06]' : 'text-white/40 active:text-white/70'
                }`}
                aria-label={`Go to ${item.label}`}
                aria-current={isActive ? 'page' : undefined}
              >
                <svg className="w-5 h-5 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" d={item.icon} />
                </svg>
                <span className="text-[10px] font-medium">{item.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MobileNav;